import { get } from 'lodash';
import { mapDateFromApiModel } from '../../dataMapper/dateDataMapper';

export const mapTemplateDataForEditor = ({
  data: {
    id,
    attributes: { description, name, is_favorite, created_at },
  },
}) => ({
  id,
  name,
  description,
  isFavorite: is_favorite,
  createDate: mapDateFromApiModel(created_at),
});

export default (
  {
    relationships,
    id,
    attributes,
    attributes: { has_items: hasItems, is_favorite: isFavorite, type_: type },
  },
  included,
) => {
  const creatorData = included.find(
    element => element.id === relationships.creator.data.id,
  ).attributes;
  const previewImageData = included.find(
    item => get(item, 'id') === get(relationships, 'preview.data.id'),
  );
  const { url: previewImgSrc } = get(previewImageData, 'attributes', {});
  const { first_name: firstName, last_name: lastName } = creatorData;

  return {
    id,
    ...attributes,
    hasItems,
    isFavorite,
    type,
    previewImgSrc,
    createDate: mapDateFromApiModel(attributes.created_at),
    createdBy: `${firstName} ${lastName}`,
  };
};
